import { render, staticRenderFns } from "./MaterialCategoryItemRecursive.vue?vue&type=template&id=6b83f6d3&scoped=true&lang=pug&"
import script from "./MaterialCategoryItemRecursive.vue?vue&type=script&lang=js&"
export * from "./MaterialCategoryItemRecursive.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCategoryItemRecursive.vue?vue&type=style&index=0&id=6b83f6d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83f6d3",
  null
  
)

export default component.exports